























import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { CompanyRole, UserScope, SystemUserRole } from '@/models/users'
import { UserActionTypes } from '@/store/modules/users/actions'
import { AxiosResponse } from 'axios'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

export default Vue.extend({
  props: {
    // Make component work as an input field with v-model support
    create: {
      type: Boolean,
      required: false,
      default: false,
    },

    disabled: {
      default: () => false,
    },

    value: {
      type: Number,
      required: false,
    },

    userId: {
      required: false,
      default() {
        return null
      },
      validator: prop => typeof prop === 'string' || prop === null,
    },

    roleId: {
      type: Number,
      required: false,
      default: SystemUserRole.User,
    },
  },

  computed: {
    ...mapGetters(['canDoScope', 'getRoleById']),

    role(): CompanyRole | undefined {
      if (this.create === true && this.value !== undefined) {
        return this.getRoleById(this.value)
      }
      return this.getRoleById(this.roleId)
    },

    roles(): CompanyRole[] {
      const roles = this.$store.state.users.roles
      const excludeRoleId = this.create === true ? this.value : this.roleId
      return roles.filter((one: CompanyRole) => one.id !== `${excludeRoleId}`)
    },

    label(): string {
      if (!this.role) {
        return ''
      }
      return this.role.name
    },

    roleClass(): object {
      return {
        input: this.create,
        '-disabled': this.isDisabled,
      }
    },

    isDisabled(): boolean {
      return (
        this.disabled ||
        (this.create === false && !this.userId) ||
        !this.canDoScope(UserScope.Roles)
      )
    },
  },

  methods: {
    ...mapActions([UserActionTypes.AssignRole]),

    changeRole(roleId: string | number) {
      const numberRoleId = Number(roleId)
      setTimeout(() => {
        if (this.create === true && this.value !== undefined) {
          this.$emit('input', numberRoleId)
          return
        }

        this[UserActionTypes.AssignRole]({
          user: this.userId,
          role: numberRoleId,
        }).then((response: AxiosResponse<boolean>) => {
          if (response.data) {
            this.$store.dispatch(ADD_TOAST_MESSAGE, {
              text: 'Роль пользователя обновлена',
              type: 'info',
            })
          }
        })
      }, 100)
    },
  },
})
